/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Accounts } from '../../models/accounts';

export interface GetAccountById$Params {
  id: number;
  skipTranslation?: boolean;
}

export function getAccountById(http: HttpClient, rootUrl: string, params: GetAccountById$Params, context?: HttpContext): Observable<StrictHttpResponse<Accounts>> {
  const rb = new RequestBuilder(rootUrl, getAccountById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('skipTranslation', params.skipTranslation, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Accounts>;
    })
  );
}

getAccountById.PATH = '/account/{id}';
